/* eslint-disable max-lines-per-function */
import { markRaw, onMounted, onUnmounted, reactive, toRaw, toRefs } from 'vue';
import { ShiningViewer, Plugins } from '@shining3d/shining-viewer';
import $store from '@/store';
import { get } from 'lodash';
import { XlMessage } from '@shining3d/ui-components';
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang( '@shining3d/app' );
export default function use3dView( clientInfo ) {
	const state = reactive({
		client: markRaw({}),
		modelList: [],
		markerList: [],
		modelLoadStatus: null,
		isLoading: true,
		isInit: false,
		isEmpty: false,
		progress: 0,
		config: {},
		loadModelCount: 0,
		needLoadModelCount: 0,
		selectModels: [],
		selectMode: null,
		animationDuration: 600,
		isReplaced: false
	});

	// 初始化
	const init = ( modelList = []) => {
		state.loadModelCount = 0;
		state.needLoadModelCount = modelList.length;
		if ( state.isInit ) {
			setData( modelList );
		} else {
			state.modelList = modelList;
		}
	};
	const setData = async ( modelList = []) => {
		state.modelList = modelList;
		state.isEmpty = Boolean( !modelList.length );
		// debugger;
		if ( state.isEmpty ) { // 数据转换中，人为增加loading时间
			setTimeout(() => {
				state.isLoading = false;
			}, 1000 );
		} else {
			await addModels( modelList );
		}
	};
	// 添加数据到三维页面
	const addModels = async ( list ) => {
		state.isLoading = true;
		await state.client.addModels( list ).then(( res ) => {
			res.forEach(( item, i ) => {
			  if ( item.status === 'success' ) {
					state.modelList[ i ].progress = item.progress;
					// state.modelList[ i ].zLength = item.zLength;
					if ( state.modelList[ i ].loadStatus !== 'success' ){
						state.modelList[ i ].loadStatus = 'success';
					}
			  } else {
					state.modelList[ i ].progress = 0;
					state.modelList[ i ].loadStatus = 'error';
			  }
			});
			state.client.setAutofitVisible( false );
			state.loadModelCount = state.needLoadModelCount;
			onViewChange( 'envisage' );
			state.isLoading = false;
		  });
	};

	const deleteModels = async ( ids ) => {
		await state.client.deleteModels( ids );
	};

	// 根据视图设置相机参数
	const updateView = async ( type, view ) => {
		// 设置相机动画和视角
		await state.client.setCameraTransition( toRaw( state.config[ type ][ view ].transition ));
		let camera = { 
			...state.config[ type ][ view ].camera,	
			zoom: view === 'open' ? state.config[ type ][ view ].camera.zoom : 8 
		};
		if ( type === 'face' ) {
			const cfg = await state.client.getDentalBaseConfig({ face: state.modelList.find(( m ) => m.classType === 'faceScan' ).id });
			const config = JSON.parse( cfg );
			camera = config.face.envisage.camera;
		}
		await state.client.setSceneParam( JSON.stringify( camera ));

		// 控制单个模型显示隐藏
		state.modelList.forEach( async ( item ) => {
			if ( item.visible ) {
				await state.client.setModelVisible( item.id, true ).then(() => {
					const myConfig = state.config[ type ][ view ][ item.modelType ];
					if ( myConfig ) {
						state.client.updateModelPosition( item.id, toRaw( myConfig.position ), toRaw( myConfig.transition ));
						state.client.updateModelRotation( item.id, toRaw( myConfig.rotation ), toRaw( myConfig.transition ));
					}
				});
			} else {
				await state.client.setModelVisible( toRaw( item ), false );
			}
		});
	};
	const onViewChange = async ( params, immediate = false, strict = false ) => {
		// 获取可见模型数据
		const visibleIdList = state.modelList.filter(( m ) => m.showStatus ).map(( item ) => item.dfsID );
		// 根据可见模型与视角，获取相机位置
		let paramsStr = '';
		try {
			paramsStr = JSON.stringify({ direction: params, idList: visibleIdList, strict });
		} catch ( error ) {
			console.log( 'JSON.stringify失败', { direction: params, idList: visibleIdList, strict });
		}
		if ( !paramsStr ) {
			return;
		}
		const config = await state.client.directionConfig( paramsStr );
	
		// 设置动画状态
		await state.client.setCameraTransition({
			duration: immediate ? 0 : state.animationDuration,
			type: 'ease'
		});
		// 设置相机，进行动画
		await state.client.setSceneParam( config );
	};

	const selectModels = ( data ) => {
		if ( Array.isArray( data )){
			state.selectModels = data;
			state.client.selectModels( data );
		}
	};
	const setSelectStatus = ( data ) => {
		if ( data ){
			const { status, mode, colorParam } = data;
			state.client.setSelectStatus({ status, mode, colorParam });
			if ( status ){
				addClientListener({ selectModel: selectModelMessage }); // 开启事件监听
			} else {
				removeClientListener({ selectModel: selectModelMessage });
			}
		}
	};
	const selectModelMessage = ( data ) => {
		if ( Array.isArray( data )){
			state.selectModels = data;
		}
	  };
	// 清空场景内容
	const clear = () => {
		state.client.clear();
	};

	// 重置视角
	const refresh = () => state.client.reset();

	// 设置相机参数
	const setSceneParam = ( data ) => {
		state.client.setSceneParam( data );
	};

	// 开闭rt变更时的自适应
	const setAutofitState = ( flag ) => state.client.setAutofitState( flag );

	// 启动新增标注
	const addingMarker = () => {
		state.client.plugin.marker.adding();
	};
	const quitAdding = () => {
		state.client.plugin.marker.quitAdding();
	};

	// 取消标注
	const cancelMarker = ( data ) => {
		state.client.plugin.marker.quitAdding();
		state.client.plugin.marker.closePopup();
		state.client.plugin.marker.remove(['temporary_marker']);
	};

	// 增加标签
	const addMarker = async ( data ) => {
		state.markerList = data;
		await state.client.plugin.marker.add( data );
	};

	// 更新标签
	const updateMarker = async ( data ) => {
		await state.client.plugin.marker.updateContext( data );
	};

	// 激活标签
	const activeMarker = ( id, flag = false ) => {
		state.client.plugin.marker.remove(['temporary_marker']);
		state.client.plugin.marker.active( id, flag );
	};

	// 删除标签
	const removeMarker = ( ids = []) => {
		state.client.plugin.marker.remove( ids );
	};

	// 清空标签
	const clearMarker = () => {
		state.client.plugin.marker.clear();
	};

	// 增加client事件监听
	const addClientListener = ( data ) => {
		for ( const e in data ) {
			state.client.event.on( e, data[ e ]);
		}
	};

	// 取消client事件监听
	const removeClientListener = ( data = { markerEdit: '', keydown: '', activeMarker: '' }) => {
		const eData = Object.assign({ init: '', progress: '' }, data );
		for ( const e in eData ) {
			state.client.event.off( e, eData[ e ]);
		}
	};

	// 击中测试
	const shootTest = ( x, y ) => new Promise(( resolve ) => {
		state.client.plugin.marker.shootTest( x, y ).then(( data ) => {
			resolve( data );
		}).
			catch(( res ) => {
				resolve( res );
			});
	});
	const swapModels = ( newModels ) => {
		state.client.deleteModels( JSON.parse( JSON.stringify( state.selectModels ))).then(() => {
			state.loadModelCount = 0;
			state.needLoadModelCount = newModels.length;
			state.isLoading = true;
			state.client.addModels( JSON.parse( JSON.stringify( newModels ))).then(( res ) => {
				res.forEach(( item, i ) => {
				  if ( item.status === 'success' ) {
						state.modelList[ i ].progress = item.progress;
						if ( state.modelList[ i ].loadStatus !== 'success' ){
							state.modelList[ i ].loadStatus = 'success';
						}
				  } else {
						state.modelList[ i ].progress = 0;
						state.modelList[ i ].loadStatus = 'error';
				  }
				});
				XlMessage({ type: 'success', message: $t( 'scannerRod.swapSuccess' ) });
				// const deleteMarkIds = [];
				// state.markerList = state.markerList.filter(( item ) => {
				// 	const flag = newModels.some(( i ) => i.id === item.modelID );
				// 	flag && deleteMarkIds.push( item.id );
				// 	return !flag;
				// });
				// removeMarker( deleteMarkIds );
				selectModels([]);
				state.loadModelCount = state.needLoadModelCount;
				state.isLoading = false;
				state.isReplaced = true;
			  });
		});
	  };

	onMounted( async () => {
		state.client = new ShiningViewer({
			// eslint-disable-next-line max-len
			access_token: '',
			appID: get( window, 'app.global.appId' ),
			url: get( window, 'app.global.threeDModelDentalPartsUrl' ),
			...clientInfo
		});
		state.client.event.on( 'init', () => {
			state.isInit = true;
			state.client.use( new Plugins.Marker());
			state.modelList.length && setData( toRaw( state.modelList ));
		});
		state.client.event.on( 'r3f_load_progress', ( data ) => {
			state.modelLoadStatus = data;
			state.progress = parseInt(( state.loadModelCount / state.needLoadModelCount ) * 100 );
			if ( state.loadModelCount < state.needLoadModelCount ) { state.loadModelCount += 1; }
		});
		// state.client.event.on( 'progress', ({ active, progress }) => {
		// 	state.progress = progress;
		// });
	});
	onUnmounted(() => {
		state.client.destroy && state.client.destroy();
	});

	const Client = {
		init,
		refresh,
		clear,
		setAutofitState,
		addingMarker,
		quitAdding,
		cancelMarker,
		addMarker,
		updateMarker,
		activeMarker,
		removeMarker,
		clearMarker,
		addClientListener,
		removeClientListener,
		setSceneParam,
		shootTest,
		updateView,
		selectModels,
		setSelectStatus,
		onViewChange,
		deleteModels,
		addModels,
		swapModels
	};

	return { ...toRefs( state ), Client };
}
